import { render, staticRenderFns } from "./SoldProducts.vue?vue&type=template&id=85f4b13c&scoped=true&"
import script from "./SoldProducts.vue?vue&type=script&lang=js&"
export * from "./SoldProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85f4b13c",
  null
  
)

export default component.exports